import { MODAL_CLEAR, MODAL_CLOSED, MODAL_OPENED } from "./type";

export const modalOpened = () => {
    return (dispatch) => {
        dispatch(
            {
                type: MODAL_OPENED
            }
        );
    }
};

export const modalClosed = () => {
    return (dispatch) => {
        dispatch(
            {
                type: MODAL_CLOSED,
            }
        );
    }
};

export const modalClear = () => {
    return (dispatch) => {
        dispatch(
            {
                type: MODAL_CLEAR,
            }
        );
    }
};